// Tracking Bikhra.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { updatePageMeta, pageMeta } from '../utils/seo.jsx';
export default function Bikhra() {
  const [isHovered, setIsHovered] = useState(false);

  // Update SEO metadata for home page
  useEffect(() => {
    updatePageMeta(pageMeta.home);

    // Hide the instant B logo now that React has loaded
    const instantLogo = document.getElementById('instant-b-logo');
    if (instantLogo) {
      instantLogo.style.display = 'none';
    }
  }, []);
  return <div className="w-full h-full flex items-center justify-center relative" style={{
    backgroundColor: '#faf8f5',
    minHeight: '100vh'
  }}>
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade {
          animation: fadeIn 0.8s ease-out 0.1s forwards;
        }
        
        .animate-fade-word-1 {
          animation: fadeIn 0.6s ease-out 0.6s forwards;
        }
        
        .animate-fade-word-2 {
          animation: fadeIn 0.6s ease-out 0.9s forwards;
        }
        
        .animate-fade-word-3 {
          animation: fadeIn 0.6s ease-out 1.2s forwards;
        }
        
        .animate-fade-delayed {
          animation: fadeIn 1.5s ease-out 1.8s forwards;
        }
      `}</style>
      
      {/* Main content */}
      <main className="text-center opacity-0 animate-fade">
        <h1 className="mb-5" style={{
        fontFamily: "'Cormorant Garamond', Georgia, serif",
        fontSize: 'clamp(3rem, 10vw, 5.5rem)',
        fontWeight: 400,
        color: '#2a2825',
        letterSpacing: '0.08em'
      }}>
          Bikhra
        </h1>
        <p style={{
        fontFamily: "'Inter', -apple-system, sans-serif",
        fontSize: 'clamp(1.02rem, 2.4vw, 1.2rem)',
        fontWeight: 300,
        color: '#5a5650',
        letterSpacing: '0.15em',
        textTransform: 'lowercase'
      }} className="mt-[-25px] mb-[-25px] ml-0 mr-0 pt-0 pb-0 pl-0 pr-0">
          <span className="inline-block opacity-0 animate-fade-word-1">scattered</span>
          {' '}
          <em className="inline-block opacity-0 animate-fade-word-2" style={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontStyle: 'italic',
          fontSize: '1.45em',
          letterSpacing: '0.05em'
        }}>
            not
          </em>
          {' '}
          <span className="inline-block opacity-0 animate-fade-word-3">broken</span>
        </p>
      </main>

      {/* Signature */}
      <div className="fixed" style={{
      bottom: '12px',
      right: '12px'
    }} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
        {/* Social Modal - positioned above B with overlap */}
        <div style={{
        position: 'absolute',
        bottom: '100%',
        right: 0,
        background: '#faf8f5',
        border: '1px solid #e8e4de',
        padding: window.innerWidth < 768 ? '1.25rem 1.75rem 1.5rem 1.75rem' : '1.5rem 2rem 2rem 2rem',
        marginBottom: '-0.5rem',
        opacity: isHovered ? 1 : 0,
        visibility: isHovered ? 'visible' : 'hidden',
        transform: isHovered ? 'translateY(0)' : 'translateY(8px)',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        pointerEvents: isHovered ? 'auto' : 'none',
        minWidth: window.innerWidth < 768 ? '260px' : '280px',
        whiteSpace: 'nowrap'
      }}>
          {/* Title */}
          <div style={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontSize: '1.1rem',
          fontWeight: 300,
          color: '#2a2825',
          letterSpacing: '0.08em',
          marginBottom: '1.25rem',
          textAlign: 'left'
        }}>
            The Bikhra Collective
          </div>
          
          {/* Books Link */}
          <Link to="/books" style={{
          fontFamily: "'Inter', -apple-system, sans-serif",
          fontSize: '0.8rem',
          fontWeight: 300,
          color: '#5a5650',
          letterSpacing: '0.05em',
          paddingBottom: '0.75rem',
          textDecoration: 'none',
          display: 'block',
          transition: 'color 0.2s ease'
        }} onMouseEnter={e => e.target.style.color = '#2a2825'} onMouseLeave={e => e.target.style.color = '#5a5650'} data-tracking-id="link-1d4d29a543a4bbbb">
            Books
          </Link>
          
          {/* Separator */}
          <div style={{
          width: '100%',
          height: '1px',
          background: '#e8e4de',
          marginBottom: '0.75rem'
        }} />
          
          {/* Social Links */}
          {[{
          label: 'ig',
          handle: '@bhanu',
          url: 'https://instagram.com/bhanu'
        }, {
          label: 'x',
          handle: '@bhanu',
          url: 'https://x.com/bhanu'
        }, {
          label: 'in',
          handle: '@bhanusharma',
          url: 'https://linkedin.com/in/bhanusharma'
        }].map((social, index) => <a key={social.label} href={social.url} target="_blank" rel="noopener noreferrer" style={{
          fontFamily: "'Inter', -apple-system, sans-serif",
          fontSize: '0.8rem',
          fontWeight: 300,
          color: '#5a5650',
          letterSpacing: '0.05em',
          paddingTop: index === 0 ? 0 : '0.5rem',
          paddingBottom: index === 2 ? 0 : '0.5rem',
          textDecoration: 'none',
          display: 'block',
          transition: 'color 0.2s ease'
        }} onMouseEnter={e => e.target.style.color = '#2a2825'} onMouseLeave={e => e.target.style.color = '#5a5650'} data-tracking-id="link-0c9da7b6f9e7285a">
              <span style={{
            color: '#a09a90',
            marginRight: '0.6rem',
            fontSize: '0.7rem',
            textTransform: 'uppercase',
            letterSpacing: '0.1em'
          }}>
                {social.label}
              </span>
              {social.handle}
            </a>)}
          
          {/* Separator */}
          <div style={{
          width: '100%',
          height: '1px',
          background: '#e8e4de',
          marginTop: '1rem',
          marginBottom: '1rem'
        }} />
          
          {/* Made with Maker */}
          <div style={{
          fontFamily: "'Inter', -apple-system, sans-serif",
          fontSize: '0.7rem',
          fontWeight: 300,
          color: '#a09a90',
          letterSpacing: '0.05em',
          textAlign: 'left'
        }}>
            Made with <a href="https://maker.co" target="_blank" rel="noopener noreferrer" style={{
            color: '#5a5650',
            textDecoration: 'none',
            transition: 'color 0.2s ease'
          }} onMouseEnter={e => e.target.style.color = '#2a2825'} onMouseLeave={e => e.target.style.color = '#5a5650'} data-tracking-id="link-7dc0c478809e46bb">
              Maker
            </a>
          </div>
        </div>

        {/* The B signature */}
        <span className="flex items-center justify-center cursor-pointer" style={{
        fontFamily: "'Cormorant Garamond', Georgia, serif",
        fontSize: '1.82rem',
        fontStyle: 'italic',
        color: isHovered ? '#5a5650' : '#a09a90',
        transition: 'color 0.3s ease',
        width: '2.6rem',
        height: '2.6rem'
      }}>
          B
        </span>
      </div>
    </div>;
}